// 下游结算审批
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of search-area -->
    <el-tabs class="process-list" v-model="activeName" @tab-click="handleClick">
      <template v-for="(item, index) in listType">
        <el-tab-pane :key="item.index" :label="item.label" :name="item.value"></el-tab-pane>
      </template>
    </el-tabs>
    <div class="search-area">
      <el-row :gutter="24" style="margin-bottom: 10px;">
        <el-col :span="6">
          <div class="search-area-div">客户名称：</div>
          <el-select filterable clearable v-model="page.paymentTenantGuid" placeholder="请选择药企" size="mini"
            class="ipt-sty">
            <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">提交日期：</div>
          <el-date-picker size="mini" v-model="timeListS" type="daterange" format="yyyy-MM-dd" range-separator="至"
            class="ipt-sty" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审批状态：</div>
          <el-select filterable clearable v-model="page.approveState" placeholder="请选择审批状态" size="mini" class="ipt-sty">
            <el-option v-for="item in approveList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="searchData()">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-show="showMore">


        <el-col :span="6">
          <div class="search-area-div">冲红原因：</div>
          <el-select filterable clearable v-model="page.hedgeReasonType" placeholder="请选择审批状态" size="mini"
            class="ipt-sty">
            <el-option v-for="item in getCodeListByKey('开票冲红原因')" :key="item.value" :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="6">
          <div class="search-area-div">业务类型：</div>
          <el-select filterable clearable v-model="page.businessCategory" placeholder="请选择审批状态" size="mini"
            class="ipt-sty">
            <el-option v-for="item in getCodeListByKey('合同内容分类')" :key="item.value" :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col> -->

      </el-row>
    </div>
    <!-- end of search-area -->

    <!-- start of content -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <!-- start of add-btn -->
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="initiate()">流程审批申请</el-button>
        <!-- <el-button size="mini" type="defalut" @click="approve()">批量审批</el-button> -->
      </div>
      <!-- end of add-btn -->

      <!-- start of table -->
      <el-table stripe border ref="multipleTable" v-loading="tableLoading" :data="tableData" :height="tableHeight">

        <!-- 序号 -->
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <!-- 客户名称 -->
        <el-table-column prop="paymentTenantName" width="180" label="客户名称" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>

        <!-- 开票主体 -->
        <el-table-column prop="invoiceTenantName" width="160" label="开票主体" header-align="center" align="left"
          show-overflow-tooltip>
        </el-table-column>

        <!-- 是否当月冲红 -->
        <el-table-column prop="isCurrentMonthHedge" width="100" label="是否当月冲红" header-align="center" align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.isCurrentMonthHedge === 'Y'">{{ '是' }}</span>
            <span v-else-if="scope.row.isCurrentMonthHedge === 'N'">{{ '否' }}</span>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>

        <!-- 冲红原因-->
        <el-table-column prop="hedgeReasonType" width="90" label="冲红原因" header-align="center" align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.hedgeReasonType | commonFilterName('开票冲红原因') }}
          </template>
        </el-table-column>

        <!-- 发起人 -->
        <el-table-column prop="applyStaffName" width="96" label="发起人" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.bizApproveVO.staffName || '-' }}
          </template>
        </el-table-column>

        <!-- 审批状态 -->
        <el-table-column prop="approveState" width="80" label="审批状态" header-align="center" align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- N 初始 A 审批中 Y 已通过 R 驳回 C 已撤销 -->
            <a class="reject-btn btn" v-if="scope.row.bizApproveVO.approveState == 'R'">已驳回</a>
            <a class="pass-btn btn"  v-if="scope.row.bizApproveVO.approveState == 'Y'">已通过</a>
            <a class="ing-btn btn" v-if="scope.row.bizApproveVO.approveState == 'A'">审批中</a>
            <a class="cancel-btn btn" v-if="scope.row.bizApproveVO.approveState == 'N'">草稿中</a>
            <a class="cancel-btn btn" v-if="scope.row.bizApproveVO.approveState == 'C'">已撤销</a>
          </template>
        </el-table-column>

        <!-- 对方是否抵扣 -->
        <el-table-column prop="isDeduct" width="100" label="对方是否抵扣" header-align="center" align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.isDeduct === 'Y'">是</span>
            <span v-else-if="scope.row.isDeduct === 'N'">否</span>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>

        <!-- 抵扣联是否回收 -->
        <el-table-column prop="isRetrieveDeduction" width="110" label="抵扣联是否回收" header-align="center" align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.isRetrieveDeduction === 'Y'">是</span>
            <span v-else-if="scope.row.isRetrieveDeduction === 'N'">否</span>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>

        <!-- 业务类型 -->
        <!-- <el-table-column prop="payTime" width="100" label="业务类型" header-align="center" align="left">
          <template slot-scope="scope">{{ getName(scope.row.businessCategory, '合同内容分类') }}</template>
        </el-table-column> -->


        <!-- 开票日期 -->
        <el-table-column prop="payTime" width="100" label="开票日期" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.invoiceDate | getDate }}</template>
        </el-table-column>


        <!-- 提交时间 -->
        <el-table-column prop="submitDate" width="130" label="提交时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.bizApproveVO.createTime | getTime }}</template>
        </el-table-column>

        <!-- 审批时间 -->
        <el-table-column prop="approveVO" width="130" label="审批时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.bizApproveVO.approveTime | getTime }}</template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" header-align="center" width="160" align="center" fixed="right">
          <template slot-scope="scope">
            <!-- 审批状态(N 初始 A 审批中 Y 已通过 R 驳回 C 已撤销) -->
            <a class="txt-color" @click="editData(scope.row, 2)"
              v-if="getListBtnState('detail', scope.row) == 'detail'">
              详情
            </a>
            <a class="txt-color" @click="toPassSubmit(scope.row)"
              v-if="getListBtnState('approval', scope.row) == 'approval'">
              通过
            </a>
            <a class="txt-color" @click="toRejectSubmit(scope.row)"
              v-if="getListBtnState('approval', scope.row) == 'approval'">
              驳回
            </a>
            <a class="txt-color" @click="cancel(scope.row)" v-if="getListBtnState('revoke', scope.row) == 'revoke'">
              撤销
            </a>
            <a class="txt-color" @click="del(scope.row.guid)"
              v-if="getListBtnState('del', scope.row) == 'del'">
              删除
            </a>
            <a class="txt-color" @click="editData(scope.row, 1)"
              v-if="getListBtnState('edit', scope.row) == 'edit'">
              编辑
            </a>
            <a
              class="txt-color"
              v-if="getListBtnState('again', scope.row) == 'again'&& scope.row.bizApproveState!='D'"
              @click="editData(scope.row, 3)"
            >
              重新提交
            </a>
          </template>
        </el-table-column>
      </el-table>
      <!-- end of table -->

      <!-- start of pagination -->
      <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :current-page="page.pageIndex"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
      </el-pagination>
      <!-- end of pagination -->
    </div>
    <!-- end of content -->



    <!-- end of dialog-驳回 -->
    <el-dialog title="填写驳回备注" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="rejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-驳回 -->

    <PassDialog 
      ref="passDialogRef" 
      :showInvoiceDate="showInvoiceDate"
      @submit="passSubmit" 
    />
  </div>
</template>

<script>
import workFlowCommon from '@/uilt/workFlowCommon';
import PassDialog from './components/PassDialog.vue';
import qs from 'qs';
import store from '@/store';
export default {
  components: {
    PassDialog,
  },
  data() {
    let userInfo = JSON.parse(localStorage.userInfo);
    return {
      fullscreenLoading: false,
      activeName: 0,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalRows: 0,
        listType: 0, // 0全部 1我发起的 2我审批的 3抄送我的 4待我审批的
        invoiceTenantGuid: null,
        approveState: null,
        startTime: null,
        endTime: null,
        hedgeReasonType: null,//冲红原因
        businessCategory: null,//业务类型
        // accountMonth:null

      },
      showMore: false, // 是否展示更多
      tableHeight: window.innerHeight - 320,
      contentMainHeight: window.innerHeight - 220,
      serviceTenantList: [],
      // (N 初始 A 审批中 Y 已通过 R 驳回 C 已撤销)
      approveList: [
        {
          label: '全部',
          value: '',
        },
        // {
        //     label: '草稿中',
        //     value: 'N'
        // },
        {
          label: '审批中',
          value: 'A',
        },
        {
          label: '已通过',
          value: 'Y',
        },
        {
          label: '驳回',
          value: 'R',
        },
        {
          label: '已撤销',
          value: 'C',
        },
      ],
      listType: [
        {
          label: '全部流程',
          value: '0',
        },
        {
          label: '待处理',
          value: '4',
        },
        {
          label: '已处理',
          value: '2',
        },
        {
          label: '我收到的',
          value: '3',
        },
        {
          label: '我发起的',
          value: '1',
        },
      ],
      tableLoading: false,
      tableData: [],
      multipleSelection: [],

      dialogFormVisible: false, // 是否展示发起流程dialog
      flowSelectType: '', // 流程类型

      dialogApprove: false, // 是否展示批量审批dialog
      approveType: '', // 审批类型

      // 驳回通过
      userInfo: '',
      rejectDialogVisible: false,
      approveSuggest: '',
      postJson: {}, // 通过驳回时获取当前行的审批数据
      timeListS: [],
      staffList: [],
      tenantList: [],
      isLastNode: false,
      showInvoiceDate: false,
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 340;
        this.contentMainHeight = window.innerHeight - 240;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 320;
        this.contentMainHeight = window.innerHeight - 220;
        return;
      }
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.userInfo);
    this.getData();
    this.getTenantList();
  },
  activated() {
    this.getData();
  },
  methods: {
    async getLastNode(row) {
      const userinfo = JSON.parse(localStorage.userInfo);
      const { bizApproveVO } = row;
      let query = {
        staffGuid: userinfo.staffGuid,
        deploymentId: bizApproveVO.camundaDeploymentId,
        processInstanceId: bizApproveVO.camundaInstanceId,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      this.isLastNode = data.data || false;
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach(item => {
          list.forEach(el => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          })
        })
        return newArr.length ? newArr.join('、') : '-';

      } else {
        let lisArr = list.filter(item => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }

    },
    /**
     * 获取客户列表
     */
    getTenantList(){
        let self = this;
        self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-send-tenants?serviceTenantGuid=${localStorage.guid}`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 获取操作按钮显隐
     * @param {*} btnType
     * @param {*} row
     */
    getListBtnState(btnType, row) {
      let approveVO = row.bizApproveVO;
      return workFlowCommon.getListBtnState(
        btnType,
        approveVO.approveState,
        approveVO.staffGuid,
        approveVO.approveStaffGuids,
        this.userInfo.staffGuid,
        approveVO.approveState,
      );
    },
    /**
     * 获取审批状态
     * @param {*} approvalState
     */
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },

    /**
     * tab条件筛选
     */
    handleClick() {
      this.page['listType'] = this.activeName;
      this.page['pageIndex'] = 1;
      this.getData();
    },
    searchData() {
      this.page['pageIndex'] = 1;
      this.tableData = [];
      this.getData();
    },
    /**
     * 获取列表数据
     */
    getData(callBack) {
      let self = this;
      self.tableLoading = true;
      if (this.timeListS && this.timeListS.length > 0) {
        this.page.startTime = this.$moment(this.timeListS[0]).format('YYYY-MM-DD HH:mm:ss');
        this.page.endTime = this.$moment(this.timeListS[1]).format('YYYY-MM-DD 23:59:59');
      }
      let postData = JSON.parse(JSON.stringify(this.page));
      postData.staffGuid=this.userInfo.staffGuid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/invoice-apply-hedge/page-list`, postData).then((res) => {
        self.tableLoading = false;
        let { code, msg, data } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = data.records || [];
          self.tableData = list;
          self.page.totalPage = data.totalPages;
          self.page.totalRows = data.totalRows;
          if (callBack) callBack()
        } else {
          self.$message.error(msg);
        }
      });
    },
    /**
     * 清空条件搜索，重新获取列表数据
     */
    empty() {
      this.timeListS = [];
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalRows: 0,
        listType: 0, // 0全部 1我发起的 2我审批的 3抄送我的 4待我审批的
        invoiceTenantGuid: null,
        approveState: null,
        startTime: null,
        endTime: null,
        hedgeReasonType: null,//冲红原因
        businessCategory: null,//业务类型
      };
      this.tableData = [];
      this.getData();
    },
    editData(row, type) {
      let addPath = 'ticketHedgingAdd';
      let detailPath = 'ticketHedingDetail';
      let query = {
        detail:encodeURIComponent(JSON.stringify(row)),
        productGuid:this.$route.query.productGuid,
        guid:row.guid,
        type
      };
      this.$router.push({
        path: type == 1 || type == 3 ? addPath : detailPath,
        query,
      });
    },
    /**
     * 驳回提交
     */
    toRejectSubmit(row) {
      let { bizApproveVO } = row;
      this.rejectDialogVisible = true;
      this.approveSuggest = '';
  
      this.postJson = {
        guid: bizApproveVO.approveGuid,
        flowType: bizApproveVO.flowType,
      };
    },
    rejectSubmit() {
      if (!this.approveSuggest) {
        return this.$message.error('请填写驳回理由');
      }
      let query = {
        ...this.postJson,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 通过提交
     */
    async toPassSubmit(row) {
      let { bizApproveVO } = row;
      await this.getLastNode(row);
      // 如果是最后一个节点，需要选择实际对冲日期
      this.showInvoiceDate = this.isLastNode;
      this.$refs.passDialogRef.open();
      this.postJson = {
        guid: bizApproveVO.approveGuid,
        flowType: bizApproveVO.flowType,
      };
    },
    passSubmit(data) {
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        ...this.postJson,
        ...data,
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$refs.passDialogRef.close();
          this.$message.success('审批通过！');
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 撤销
     * @param {*} item
     */
    cancel(item) {
      let self = this;
      let { bizApproveVO } = item;
      this.$confirm('撤销后,该流程将不再进行审核,确定这样操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: bizApproveVO.approveGuid,
            flowType: bizApproveVO.flowType,
            approveStaffGuid: bizApproveVO.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              self.getData();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    /**
     * 删除
     * @param {*} guid
     */
     del(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/invoice-apply-hedge/del`, [guid])
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getData();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    /**
     * 流程审批申请
     */
    initiate() {
      this.$router.push({
        path: '/ticketHedgingAdd',
        query: {
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    /**
     * 修改当前页的数量
     * @param {*} val
     */
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getData();
    },
    /**
     * 修改分页
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.page.pageIndex = val || 1;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.search-area-div {
  // width: 120px;
  text-align: right;
}

.el-tab-sty {
  padding-left: 15px;
  border-radius: 6px 6px 0 0;
}

.flow-dialog {
  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  .initiate-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 85px 0px;
  }

  .flow-item {
    width: 200px;
    height: 90px;
    margin-right: 24px;
    text-align: center;
    line-height: 90px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    font-weight: 500;
  }

  .flow-item:hover,
  .flow-item-active {
    color: #fff;
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    border-radius: 2px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }
}

a.txt-color+a.txt-color::before {
  content: '|';
  display: inline-block;
}

.reject-btn.btn {
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #fb2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.pass-btn.btn {
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1ba854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #ff991c;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #f5f5f5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ipt-sty {
  width: 74% !important;
}

/deep/ .el-col-6 {
  display: flex;
}

.process-list {
  background: #fff !important;
  overflow-y: auto;
}

.process-list /deep/ .el-tabs__header {
  margin: 0 0 8px;
}

.process-list /deep/ .el-tabs__nav-scroll {
  padding: 0 12px;
}

.process-list /deep/ .el-tabs__nav-wrap::after {
  background-color: #e9eef3;
}

/deep/ .number input::-webkit-outer-spin-button,
/deep/ .number input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/deep/ .number input[type='number'] {
  -moz-appearance: textfield;
}

/deep/ .number2 inpit {
  border: none;
}
</style>
